var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"button-edit-cms-content",on:{"click":_vm.clickButton}},[_c('img',{attrs:{"src":require("assets/img/svg/common/edit.svg")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }